import {ButtonWithIcon} from '@/components/atoms'
import {FileUploadWithModal} from '@/components/organisms'
import {useProductButtonContainer} from './ProductButtonContainer-hook'

export const ProductButtonContainer = () => {
  const {isModal, toggleModal, setFormData, formData} = useProductButtonContainer()
  return (
    <div className="productListBtnSection mb-6 mt-9 flex justify-between gap-5">
      <div>
        <ButtonWithIcon
          handleButton={() => toggleModal(true)}
          iconLeading="add_box"
          uiSchema={{
            title: 'Product Enrichment',
            size: 'medium',
            variant: 'primary',
          }}
        />
        <ButtonWithIcon
          handleButton={() => {}}
          iconLeading="add_box"
          uiSchema={{
            title: 'Multiple Images',
            size: 'medium',
            variant: 'primary',
          }}
        />
      </div>
      <div>
        <ButtonWithIcon
          handleButton={() => {}}
          iconLeading="file_download"
          uiSchema={{
            title: 'Product List Template',
            size: 'medium',
            isDark: true,
            variant: 'secondary',
          }}
        />
      </div>
      <FileUploadWithModal
        openUpload={isModal}
        setOpenUpload={toggleModal}
        setFormData={setFormData}
        formData={formData}
        title="Upload Product Template"
        showTertiaryButton={true}
      />
    </div>
  )
}
